/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Slider from 'react-slick';
import MetaData from './MetaData';

class FramePopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0
    };
    this.mainSliderRef = React.createRef();
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }

  handleKeyDown = (e) => {
    if (e.key === 'Escape' && this.props.show) {
      this.props.onHide();
    }
  };

  goToSlide = (index) => {
    if (this.mainSliderRef.current) {
      this.mainSliderRef.current.slickGoTo(index);
    }
  };

  render() {
    const { show, onHide, selectedFrame } = this.props;
    const rawImages = selectedFrame && selectedFrame.get('images');
    const images = rawImages ? (typeof rawImages.toJS === 'function' ? rawImages.toJS() : Array.isArray(rawImages) ? rawImages : []) : [];
    const hasMultipleImages = images.length > 1;

    const mainSliderSettings = {
      dots: false,
      infinite: images.length > 1,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: hasMultipleImages,
      swipe: hasMultipleImages,
      swipeToSlide: hasMultipleImages,
      draggable: hasMultipleImages,
      touchThreshold: 10,
      lazyLoad: true,
      fade: true,
      cssEase: 'ease-in-out',
      autoplay: hasMultipleImages,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      beforeChange: (_, next) => this.setState({ currentSlide: next }),
      prevArrow: <button type="button" className="frame-popup-arrow frame-popup-prev" aria-label="Previous image"><span className="frame-popup-arrow-icon">‹</span></button>,
      nextArrow: <button type="button" className="frame-popup-arrow frame-popup-next" aria-label="Next image"><span className="frame-popup-arrow-icon">›</span></button>
    };

    return (
      <Modal
        show={show}
        onHide={onHide}
        bsSize="large"
        dialogClassName="frame-details-modal"
        aria-labelledby="frame-details-modal-title"
        aria-describedby="frame-details-modal-desc"
      >
        <Modal.Header closeButton>
          <Modal.Title id="frame-details-modal-title">
          Frame Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body id="frame-details-modal-desc">
          <div className="frame-details-content">
            <div className="frame-details-gallery">
              {images.length > 0 ? (
                hasMultipleImages ? (
                  <>
                    <div className="frame-details-main-slider">
                      <Slider ref={this.mainSliderRef} {...mainSliderSettings}>
                        {images.map((item, i) => (
                          <div key={item.id || i} className="frame-details-slide">
                            <div className="frame-details-slide-inner">
                              <img
                                src={item.src}
                                alt={item.alt || (selectedFrame && selectedFrame.get('name')) || `Frame view ${i + 1}`}
                                loading="lazy"
                              />
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                    <div className="frame-details-thumbs" role="tablist" aria-label="Image thumbnails">
                      {images.map((item, i) => (
                        <button
                          key={item.id || i}
                          type="button"
                          className={`frame-details-thumb ${this.state.currentSlide === i ? 'active' : ''}`}
                          onClick={() => this.goToSlide(i)}
                          aria-label={`View image ${i + 1}`}
                        >
                          <img src={item.src} alt="" />
                        </button>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="frame-details-single-image">
                    <img
                      src={images[0].src}
                      alt={images[0].alt || (selectedFrame && selectedFrame.get('name'))}
                      loading="lazy"
                    />
                  </div>
                )
              ) : (
                <div className="frame-details-no-image">No images available</div>
              )}
            </div>
            <div className="frame-details-specs">
              <h4 className="frame-details-specs-title">Frame Specifications</h4>
              <div className="frame-details-specs-card">
                <MetaData {...this.props} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default FramePopUp;
